import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class CreditLimitExceededMessageFeature implements IFlagFeature {
  name = Features.CREDIT_LIMIT_EXCEEDED_MESSAGE;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
